import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pb-1" }
const _hoisted_2 = { class: "pb-2 text-muted" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 form-group pb-3 mb-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger mb-2"
}
const _hoisted_6 = { class: "col-md-6 form-group pb-3 mb-2" }
const _hoisted_7 = {
  key: 0,
  class: "text-danger mb-2"
}
const _hoisted_8 = { class: "form-group pb-3 mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger mb-2"
}
const _hoisted_10 = { class: "form-group pb-3 mb-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-danger mb-2"
}
const _hoisted_12 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_13 = {
  key: 1,
  class: "alert alert-success mt-3"
}

import { ref, Ref, onMounted } from "vue"
    import { IReCaptchaComposition, useReCaptcha } from 'vue-recaptcha-v3'
    import router from "@/router"
    import Spinner from "@/components/general/Spinner.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactForm',
  props: {
      isPopup: {
        type: Boolean,
        default: false
      }
    },
  emits: ['form-submitted'],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    var formData: Ref<any> = ref({
        name: "",
        telephone: "",
        email: "",
        message: ""
    })
    var formValidate: Ref<any> = ref({
        name: "",
        telephone: "",
        email: "",
        message: ""
    })
    const nameInput: Ref<any> = ref()
    var recapthcaObject: Ref<any | undefined> = ref(undefined)
    var isSubmitting: Ref<boolean> = ref(false)
    var formSubmitted: Ref<boolean> = ref(false)
    var formError: Ref<string | undefined> = ref(undefined)

    async function recaptcha(callback: any) {
      if (recapthcaObject.value) {
        const token = await recapthcaObject.value.executeRecaptcha(`${process.env.VUE_APP_FORM_KEY_CONTACT}`)
        callback(token)
      }
    }

    function validate () {
        var isValid = true
        Object.values(document.querySelectorAll("#ContactForm [required]")).forEach((input: any) => {
            const key = input.name
            const value = formData.value[key]
            if (value == null || value == "") {
                formValidate.value[key] = "This field is required."
                document.querySelector(`[name*='${key}']`)?.classList.add("invalid-flag")
                isValid = false
            }
            else {
                formValidate.value[key] = ""
                document.querySelector(`[name*='${key}']`)?.classList.remove("invalid-flag")
            }
        })
        if (!isValid) {
            return false
        }

        isSubmitting.value = true
        recaptcha((token: any) => {formPost(token)})
    }
    
    async function formPost (recaptchaResult: string) {
        const FormContent = formData.value
        const formKey = process.env.VUE_APP_FORM_KEY_CONTACT || ""
        const endpoint = process.env.VUE_APP_FORM_ENDPOINT ? process.env.VUE_APP_FORM_ENDPOINT+ "/api/forms/" + formKey : ""
        const store_only = process.env.VUE_APP_FORM_STORE_ONLY === "true" ? true : false
        const email = formData.value.email

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "GoogleRecaptchaResponse": recaptchaResult,
                FormContent,
                "StoreOnly": store_only,
                "EmailAddress": email
            })
        }

        formError.value = ""
        let res: any
        try {
            res = await fetch(endpoint, options)
                .then(result => {
                    if (result.status === 200) {
                        isSubmitting.value = false
                        formSubmitted.value = true
                        
                        if (props.isPopup) {
                            emit('form-submitted', true);
                            formData.value = { name: "", telephone: "", email: "", message: "" };
                        }

                        return result.json().then((data) => { /*Ref = data.resultData;*/ })
                    }
                    else {
                        isSubmitting.value = false
                        formError.value = 'Error submitting data.'
                        if (props.isPopup) {
                            emit('form-submitted', false);
                        }
                    }
                })
        } catch (e: any) {
            isSubmitting.value = false
            formError.value = `Error submitting data. ${e}`
            if (props.isPopup) {
                emit('form-submitted', false);
            }
            throw new Error(e)
        }
    }
    onMounted(async () => {
        recapthcaObject.value = useReCaptcha() as IReCaptchaComposition
        
        if (!props.isPopup) {
            setTimeout(() => {
                if (router.currentRoute.value.hash.includes("ContactUs") && nameInput.value != null) {
                    nameInput.value.focus()
                }
            }, 200)
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(props.isPopup ? 'Quick Enquiry' : 'Bring Your Vision to Life'), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(props.isPopup ? 'Tell us about your project.' : 'Ready to turn your concept into a digital reality? Reach out to our team to explore how we can build something extraordinary together.'), 1),
    (!_unref(formSubmitted))
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          id: "ContactForm",
          onSubmit: _withModifiers(validate, ["prevent"]),
          action: "#",
          class: "position-relative"
        }, [
          _createVNode(Spinner, {
            isAbsolute: true,
            visible: _unref(isSubmitting)
          }, null, 8, ["visible"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                ref_key: "nameInput",
                ref: nameInput,
                type: "text",
                class: "form-control",
                id: "form-name",
                name: "name",
                placeholder: "Name *",
                required: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).name) = $event))
              }, null, 512), [
                [_vModelText, _unref(formData).name]
              ]),
              (_unref(formValidate).name)
                ? (_openBlock(), _createElementBlock("i", _hoisted_5, _toDisplayString(_unref(formValidate).name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                class: "form-control",
                id: "form-subject",
                name: "telephone",
                placeholder: "Telephone *",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).telephone) = $event))
              }, null, 512), [
                [_vModelText, _unref(formData).telephone]
              ]),
              (_unref(formValidate).telephone)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7, _toDisplayString(_unref(formValidate).telephone), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-control",
              id: "form-email",
              name: "email",
              placeholder: "Email Address *",
              required: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).email) = $event))
            }, null, 512), [
              [_vModelText, _unref(formData).email]
            ]),
            (_unref(formValidate).email)
              ? (_openBlock(), _createElementBlock("i", _hoisted_9, _toDisplayString(_unref(formValidate).email), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              id: "form-message",
              name: "message",
              placeholder: "Message *",
              required: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).message) = $event))
            }, "            ", 512), [
              [_vModelText, _unref(formData).message]
            ]),
            (_unref(formValidate).message)
              ? (_openBlock(), _createElementBlock("i", _hoisted_11, _toDisplayString(_unref(formValidate).message), 1))
              : _createCommentVNode("", true)
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            class: "btn btn-dark text-white py-3 px-5 mt-4 w-100",
            type: "submit"
          }, " Submit Enquiry ", -1)),
          (_unref(formError))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(formError)), 1))
            : _createCommentVNode("", true)
        ], 32))
      : (!props.isPopup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Thank you for contacting us, we will get back to you shortly. "))
        : _createCommentVNode("", true)
  ], 64))
}
}

})